import React, { useCallback } from 'react'
import { intl } from 'lang/intl'

import { TtButton, TtIcon, TtTooltip } from '@23/react'

import { toggleScreenSharing } from '../../../../webrtc/blocs/screenSharing'
import { useLocalParticipant } from '../../../../webrtc/webRTCRoom'

export const ScreenShare = () => {
  const localParticipant = useLocalParticipant()
  const screenShareMediaStreamEnabled =
    localParticipant?.tracks.screen?.isEnabled

  const getTooltipContent = useCallback(() => {
    return screenShareMediaStreamEnabled
      ? intl.formatMessage({ defaultMessage: 'Stop screen sharing' })
      : intl.formatMessage({ defaultMessage: 'Share your screen' })
  }, [screenShareMediaStreamEnabled])

  type ButtonColor = HTMLTtButtonElement['color']

  const buttonColor: ButtonColor = screenShareMediaStreamEnabled
    ? 'info'
    : 'secondary'

  return (
    <TtTooltip content={getTooltipContent()} placement="left" distance={16}>
      <TtButton circle onClick={toggleScreenSharing} color={buttonColor}>
        <TtIcon library="one/webinars" name="screen-share" />
      </TtButton>
    </TtTooltip>
  )
}
